/** The history card's contents: loading, a failed load, or the audit log itself. */
import type { TicketSalesCampaignDiscountType } from '@bonsai/shared';

import AuditLog from '../../audit/AuditLog';
import { useTicketSalesCampaignHistory } from '../use-ticket-sales-campaigns';

import { campaignHistoryEntries, formatEasternMoment } from './campaign-history';

export interface CampaignHistoryBodyProps {
  campaignId: string;
  /** Reads amounts the history does not say the type of. */
  discountType: TicketSalesCampaignDiscountType;
}

export function CampaignHistoryBody({ campaignId, discountType }: CampaignHistoryBodyProps) {
  const history = useTicketSalesCampaignHistory(campaignId);
  if (history.isPending) {
    return <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>Loading the history…</div>;
  }
  if (history.isError) {
    return (
      <div role="alert" style={{ fontSize: 12, color: 'var(--nb-warn)' }}>
        The change history couldn’t be loaded. Refresh the page to try again.
      </div>
    );
  }
  return (
    <AuditLog
      audit={campaignHistoryEntries(history.data, discountType)}
      formatTime={formatEasternMoment}
    />
  );
}
